import { JsonLd } from "@/components/json-ld";
import {
  getArtistDirectoryIdentity,
  type ArtistDirectorySearchState,
} from "@/features/feature-page/artist-directory-query";
import { ArtistDirectoryStructuredData } from "@/features/feature-page/artist-directory-structured-data";
import type { FeaturePageRenderModel } from "@garimpa/api/featurePages/types";

export function FeaturePageStructuredData({
  page,
  search,
}: {
  page: FeaturePageRenderModel;
  search: ArtistDirectorySearchState;
}) {
  const directory = getArtistDirectoryIdentity(page);
  if (directory)
    return <ArtistDirectoryStructuredData page={page} directory={directory} search={search} />;
  return <JsonLd data={page.structuredData} />;
}
